import { createContext, useContext } from 'react';

export type UserRequestsCounters = Record<string, number>;

export type UserRequestsContextValue = {
  counters: UserRequestsCounters;
};

const UserRequestsContext = createContext<UserRequestsContextValue | undefined>(
  undefined,
);

export function useUserRequestsContext(): UserRequestsContextValue {
  const ctx = useContext(UserRequestsContext);
  if (!ctx) {
    throw new Error(
      'useUserRequestsContext must be used within a UserRequestsContext.Provider',
    );
  }
  return ctx;
}

export const UserRequestsContextProvider = UserRequestsContext.Provider;
